import React from "react";
import { useNavigate } from "react-router-dom";

import { FaDollarSign, FaBan, FaArrowUp, FaUndo } from "react-icons/fa";
import PrimaryButton from "../../UI/DesignStandards/Buttons/PrimaryButton";
import SecondaryButton from "../../UI/DesignStandards/Buttons/SecondaryButton";
import { signupMoney, signupPlacement } from "../../../utility/signupDashboard";
import { useTournamentId, useTournamentSlug } from "../../../context/TournamentRouteContext";
import { tournamentPath } from "../../../utility/tournamentUrls";

const ActionButtons = ({
  signup,
  actionLoading,
  onMarkPaid,
  onMarkUnpaid,
  onRemove,
  onPromote,
  onMove,
  onRefundStay,
  onRefundRemove,
}) => {
  const navigate = useNavigate();
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();
  const placement = signupPlacement(signup);
  const money = signupMoney(signup);

  if (actionLoading) {
    return (
      <div className="card-board p-6">
        <p className="text-sm text-brand-muted">Updating…</p>
      </div>
    );
  }

  if (placement === "cancelled" || placement === "denied") {
    return null;
  }

  return (
    <div className="card-board p-6">
      <h3 className="text-lg font-semibold text-brand-charcoal mb-4">
        Actions
      </h3>
      <div className="flex flex-col lg:flex-row flex-wrap gap-3">
        {placement === "waitlist" ? (
          <PrimaryButton
            onClick={onPromote}
            className="flex items-center gap-2 w-full lg:w-auto"
          >
            <FaArrowUp className="w-4 h-4" />
            Put on squad
          </PrimaryButton>
        ) : null}

        {placement === "on_squad" && money === "due" ? (
          <PrimaryButton
            onClick={onMarkPaid}
            className="flex items-center gap-2 w-full lg:w-auto"
          >
            <FaDollarSign className="w-4 h-4" />
            Mark paid
          </PrimaryButton>
        ) : null}

        {placement === "on_squad" && money === "paid" && signup.paymentID ? (
          <>
            <PrimaryButton
              onClick={onRefundRemove}
              className="flex items-center gap-2 w-full lg:w-auto"
            >
              <FaUndo className="w-4 h-4" />
              Refund and remove
            </PrimaryButton>
            <SecondaryButton
              onClick={onRefundStay}
              className="flex items-center gap-2 w-full lg:w-auto"
            >
              Refund and stay
            </SecondaryButton>
          </>
        ) : null}

        {placement === "on_squad" &&
        (money === "walk_up" ||
          (money === "paid" && !signup.paymentID)) ? (
          <SecondaryButton
            onClick={onMarkUnpaid}
            className="flex items-center gap-2 w-full lg:w-auto"
          >
            Mark unpaid
          </SecondaryButton>
        ) : null}

        <SecondaryButton
          onClick={() =>
            navigate(tournamentPath(tournamentSlug, `/signup-edit/${signup.id}`))
          }
          className="flex items-center gap-2 w-full lg:w-auto"
        >
          Edit
        </SecondaryButton>

        <SecondaryButton
          onClick={onMove}
          className="flex items-center gap-2 w-full lg:w-auto"
        >
          Move
        </SecondaryButton>

        {placement === "waitlist" ||
        !(money === "paid" && signup.paymentID) ? (
          <SecondaryButton
            onClick={onRemove}
            className="flex items-center gap-2 w-full lg:w-auto"
          >
            <FaBan className="w-4 h-4" />
            {placement === "waitlist" ? "Remove from waitlist" : "Remove from squad"}
          </SecondaryButton>
        ) : null}
      </div>
    </div>
  );
};

export default ActionButtons;
